export function getSelectedKey(state) {
	if (state.ui.selectedEnvironment && state.ui.selectedTenant) {
		return `${state.ui.selectedTenant}-${state.ui.selectedEnvironment}`; // returns deepimpact-test
	}
	return undefined;
}
